/**
 * ETML
 * @ De: Theo Bensaci
 * @ Date: 17:20 19.04.2023
 * @ Description: Main menu
 */


import "./index.css"
import MyButton from "../../compenent/button/MyButton";
import GamePageManager from "../../utils/GamePageManager";
import api from "../../utils/api";

export default function MainMenu() {
  return (
    <div className="GamePage MainMenu">
      <div className="GameLogo"></div>
      <div className="Menu">
        <MyButton title={"Play"} fontSize={100} onClick={()=>GamePageManager.changePage("GameLoading")}/>
        <div>
          <MyButton title={"About"} fontSize={50} onClick={()=>GamePageManager.changePage("About")}/>  
          {(api.isOnline)?<MyButton title={"Top10"} fontSize={50} onClick={()=>GamePageManager.changePage("Top10")}/>:null}  
          <MyButton title={"Credit"} fontSize={50} onClick={()=>GamePageManager.changePage("Credit")}/>
        </div>
      </div>
    </div>
  );
}

